module.exports = __webpack_public_path__ + "img/1717384897126-WhatsApp Image 2024-06-03 at 08.48.41 1.jpeg.f238aba0.webp";